(()=>{"use strict";if(window.SCSReviewLightbox)return;const MEDIA_SELECTOR='[onclick*="StampedFn.openUGCPhoto"]',ROOT_ID="scs-review-lightbox",STYLE_ID="scs-review-lightbox-styles";let lastTrigger=null,priorBodyOverflow="",priorBodyPaddingRight="",observer=null,gallery=[],galleryIndex=0;const styles=`
    #${ROOT_ID}[hidden] { display: none !important; }
    #${ROOT_ID} {
      position: fixed;
      inset: 0;
      z-index: 2147483647;
      display: grid;
      place-items: center;
      padding: 24px;
      font-family: Roboto, Arial, sans-serif;
    }
    #${ROOT_ID} .scs-review-lightbox__backdrop {
      position: absolute;
      inset: 0;
      display: block !important;
      background: rgba(10, 10, 11, 0.88);
      cursor: zoom-out;
    }
    #${ROOT_ID} .scs-review-lightbox__dialog {
      position: relative;
      z-index: 1;
      width: min(520px, 100%);
      max-height: calc(100vh - 48px);
      display: flex;
      flex-direction: column;
      overflow: hidden;
      border-radius: 12px;
      background: #FFFFFF;
      box-shadow: 0 24px 80px rgba(0, 0, 0, 0.55);
      outline: none;
    }
    #${ROOT_ID} .scs-review-lightbox__close {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 3;
      width: 36px;
      height: 36px;
      display: inline-grid;
      place-items: center;
      border: 0;
      border-radius: 999px;
      background: rgba(0, 0, 0, 0.55);
      color: #FFFFFF;
      cursor: pointer;
      font: 700 22px/1 Arial, sans-serif;
    }
    #${ROOT_ID} .scs-review-lightbox__close:hover { background: #ED1B34; }
    #${ROOT_ID} .scs-review-lightbox__close:focus-visible {
      outline: none;
      box-shadow: 0 0 0 3px rgba(237, 27, 52, 0.35);
    }
    #${ROOT_ID} .scs-review-lightbox__media-wrapper {
      position: relative;
      flex: 0 0 auto;
      background: #111;
      width: 100%;
    }
    #${ROOT_ID} .scs-review-lightbox__nav {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 3;
      width: 36px;
      height: 36px;
      border: 0;
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.92);
      color: #0A0A0B;
      cursor: pointer;
      display: inline-grid;
      place-items: center;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }
    #${ROOT_ID} .scs-review-lightbox__nav:hover { background: #fff; }
    #${ROOT_ID} .scs-review-lightbox__nav:disabled {
      opacity: 0.35;
      cursor: default;
    }
    #${ROOT_ID} .scs-review-lightbox__nav--prev { left: 10px; }
    #${ROOT_ID} .scs-review-lightbox__nav--next { right: 10px; }
    #${ROOT_ID} .scs-review-lightbox__nav svg {
      width: 10px;
      height: 16px;
      display: block;
    }
    #${ROOT_ID} .scs-review-lightbox__media {
      position: relative;
      min-height: 220px;
      max-height: min(52vh, 480px);
      display: grid;
      place-items: center;
      overflow: hidden;
      width: 100%;
    }
    #${ROOT_ID} .scs-review-lightbox__media img,
    #${ROOT_ID} .scs-review-lightbox__media video {
      display: block;
      max-width: 100%;
      max-height: min(52vh, 480px);
      width: auto;
      height: auto;
      object-fit: contain;
      background: #111;
    }
    #${ROOT_ID} .scs-review-lightbox__media video { width: 100%; }
    #${ROOT_ID} .scs-review-lightbox__body {
      flex: 1 1 auto;
      min-height: 0;
      overflow: auto;
      padding: 18px 20px 22px;
      background: #fff;
      color: #0A0A0B;
      -webkit-overflow-scrolling: touch;
    }
    #${ROOT_ID} .scs-review-lightbox__meta {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px 12px;
      margin: 0 0 10px;
      font-size: 13px;
      line-height: 1.3;
      color: #545454;
    }
    #${ROOT_ID} .scs-review-lightbox__author {
      font-family: Oswald, Arial, sans-serif;
      font-weight: 600;
      font-size: 15px;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      color: #0A0A0B;
    }
    #${ROOT_ID} .scs-review-lightbox__stars {
      display: inline-flex;
      gap: 2px;
      color: #f5a623;
      letter-spacing: 1px;
      font-size: 14px;
      line-height: 1;
    }
    #${ROOT_ID} .scs-review-lightbox__title {
      margin: 0 0 8px;
      font-family: Oswald, Arial, sans-serif;
      font-size: 18px;
      font-weight: 600;
      line-height: 1.25;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      color: #0A0A0B;
    }
    #${ROOT_ID} .scs-review-lightbox__text {
      margin: 0;
      font-size: 15px;
      line-height: 1.45;
      color: #222;
      white-space: pre-wrap;
      overflow-wrap: break-word;
    }
    #${ROOT_ID} .scs-review-lightbox__error {
      margin: 0;
      padding: 48px 24px;
      color: #FFFFFF;
      text-align: center;
    }
    #${ROOT_ID}.is-single .scs-review-lightbox__nav { display: none; }
    ${MEDIA_SELECTOR} { cursor: zoom-in; }
    ${MEDIA_SELECTOR}:focus-visible {
      outline: 3px solid #ED1B34;
      outline-offset: 3px;
    }
    @media (max-width: 640px) {
      #${ROOT_ID} { padding: 16px; align-items: center; }
      #${ROOT_ID} .scs-review-lightbox__dialog {
        width: 100%;
        max-height: calc(100dvh - 32px);
        min-height: auto;
        border-radius: 12px;
      }
      #${ROOT_ID} .scs-review-lightbox__media {
        max-height: 40dvh;
        min-height: 200px;
      }
      #${ROOT_ID} .scs-review-lightbox__media img,
      #${ROOT_ID} .scs-review-lightbox__media video {
        max-height: 40dvh;
      }
      #${ROOT_ID} .scs-review-lightbox__body { padding: 16px; }
    }
    @media (prefers-reduced-motion: reduce) {
      #${ROOT_ID} *, #${ROOT_ID} *::before, #${ROOT_ID} *::after {
        scroll-behavior: auto !important;
        transition: none !important;
        animation: none !important;
      }
    }
  `;function createUi(){if(!document.getElementById(STYLE_ID)){const style=document.createElement("style");style.id=STYLE_ID,style.textContent=styles,document.head.appendChild(style)}const root2=document.createElement("div");return root2.id=ROOT_ID,root2.hidden=!0,root2.setAttribute("aria-hidden","true"),root2.innerHTML=`
      <div class="scs-review-lightbox__backdrop" data-scs-review-close></div>
      <section class="scs-review-lightbox__dialog" role="dialog" aria-modal="true"
        aria-label="Customer review media" tabindex="-1">
        <button class="scs-review-lightbox__close" type="button"
          aria-label="Close customer media" data-scs-review-close>&times;</button>
        <div class="scs-review-lightbox__media-wrapper">
          <button type="button" class="scs-review-lightbox__nav scs-review-lightbox__nav--prev" data-scs-review-prev aria-label="Previous review">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none" aria-hidden="true"><path d="M8.5 1.5L1.5 8L8.5 14.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
          <button type="button" class="scs-review-lightbox__nav scs-review-lightbox__nav--next" data-scs-review-next aria-label="Next review">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none" aria-hidden="true"><path d="M1.5 1.5L8.5 8L1.5 14.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
          <div class="scs-review-lightbox__media" aria-live="polite"></div>
        </div>
        <div class="scs-review-lightbox__body" data-scs-review-body></div>
      </section>`,document.body.appendChild(root2),root2.addEventListener("click",event=>{event.target.closest("[data-scs-review-close]")&&close(),event.target.closest("[data-scs-review-prev]")&&showRelative(-1),event.target.closest("[data-scs-review-next]")&&showRelative(1)}),root2.addEventListener("keydown",trapFocus),root2}const root=createUi(),dialog=root.querySelector(".scs-review-lightbox__dialog"),mediaHolder=root.querySelector(".scs-review-lightbox__media"),bodyHolder=root.querySelector("[data-scs-review-body]"),closeButton=root.querySelector(".scs-review-lightbox__close"),prevButton=root.querySelector("[data-scs-review-prev]"),nextButton=root.querySelector("[data-scs-review-next]");function textOf(el){return el?String(el.textContent||"").replace(/\s+/g," ").trim():""}function getTrigger(eventTarget){return eventTarget instanceof Element?eventTarget.closest(MEDIA_SELECTOR):null}function getImageElement(trigger){return trigger.matches("img")?trigger:trigger.querySelector("img")}function extractReviewMeta(reviewEl){return reviewEl?{author:textOf(reviewEl.querySelector(".author")),date:textOf(reviewEl.querySelector(".created")),title:textOf(reviewEl.querySelector(".review-title, .stamped-review-header-title, h3")),body:textOf(reviewEl.querySelector(".stamped-review-content .stamped-review-content-body, .stamped-review-content-body, .stamped-review-body, .stamped-review-content")),rating:reviewEl.querySelectorAll(".stamped-fa-star-checked, .stamped-starrating .stamped-fa-star.stamped-fa-star-checked").length}:{}}function mediaInfo(trigger){const image=getImageElement(trigger),poster=image?.getAttribute("src")||image?.dataset.src||image?.currentSrc||"",href=trigger.matches("a")?trigger.getAttribute("href"):trigger.closest("a")?.getAttribute("href"),classContext=`${trigger.className||""} ${trigger.closest(".stamped-video")?.className||""}`,isVideo=/\/uploads\/videos\//i.test(poster)||/stamped-video/i.test(classContext),alt=image?.getAttribute("alt")||image?.getAttribute("aria-label")||"Customer-submitted review media";let src=href||poster;if(isVideo)src=poster.replace(/\.jpe?g(?:\?.*)?$/i,".mp4");else if(src)try{const url=new URL(src,location.href);trigger.matches("a")||url.searchParams.delete("tr"),src=url.href}catch{}const reviewEl=trigger.closest(".stamped-review, li.stamped-review"),meta=extractReviewMeta(reviewEl),authorMatch=alt.match(/Customer (?:Photo|Video) From (.+)$/i);return{type:isVideo?"video":"image",src,poster,alt,author:meta.author||(authorMatch?authorMatch[1]:""),date:meta.date||"",title:meta.title||"",body:meta.body||"",rating:meta.rating||0}}function collectGalleryFromTrigger(trigger){const triggers=[...(trigger.closest("#scs-biz3-reviews, .scs-biz3-reviews, .stamped-main-widget, #stamped-main-widget, body")||document).querySelectorAll(MEDIA_SELECTOR)],items=[],seen=new Set;return triggers.forEach(el=>{const info=mediaInfo(el);!info.src||seen.has(info.src)||(seen.add(info.src),items.push(info))}),items}function showError(){mediaHolder.replaceChildren();const message=document.createElement("p");message.className="scs-review-lightbox__error",message.textContent="This customer media could not be loaded. Please close the viewer and try again.",mediaHolder.appendChild(message)}function renderStars(count){const n=Math.max(0,Math.min(5,Number(count)||0));return n?"\u2605".repeat(n)+"\u2606".repeat(5-n):""}function renderItem(item){if(!item||!item.src)return;mediaHolder.replaceChildren(),bodyHolder.replaceChildren();let media;if(item.type==="video"){media=document.createElement("video"),media.controls=!0,media.playsInline=!0,media.preload="metadata",media.poster=item.poster||"",media.setAttribute("aria-label",item.alt||"Customer video");const source=document.createElement("source");source.src=item.src,source.type="video/mp4",media.appendChild(source),media.addEventListener("error",showError,{once:!0})}else media=document.createElement("img"),media.src=item.src,media.alt=item.alt||"Customer photo",media.decoding="async",media.addEventListener("error",showError,{once:!0});mediaHolder.appendChild(media);const meta=document.createElement("div");if(meta.className="scs-review-lightbox__meta",item.author){const author=document.createElement("span");author.className="scs-review-lightbox__author",author.textContent=item.author,meta.appendChild(author)}if(item.rating){const stars=document.createElement("span");stars.className="scs-review-lightbox__stars",stars.setAttribute("aria-label",`${item.rating} out of 5 stars`),stars.textContent=renderStars(item.rating),meta.appendChild(stars)}if(item.date){const date=document.createElement("span");date.textContent=item.date,meta.appendChild(date)}if(meta.childNodes.length&&bodyHolder.appendChild(meta),item.title){const title=document.createElement("h3");title.className="scs-review-lightbox__title",title.textContent=item.title,bodyHolder.appendChild(title)}if(item.body){const text=document.createElement("p");text.className="scs-review-lightbox__text",text.textContent=item.body,bodyHolder.appendChild(text)}const multi=gallery.length>1;root.classList.toggle("is-single",!multi),prevButton.disabled=!multi||galleryIndex<=0,nextButton.disabled=!multi||galleryIndex>=gallery.length-1}function lockScroll(){priorBodyOverflow=document.body.style.overflow,priorBodyPaddingRight=document.body.style.paddingRight;const scrollbarWidth=window.innerWidth-document.documentElement.clientWidth;scrollbarWidth>0&&(document.body.style.paddingRight=`${scrollbarWidth}px`),document.body.style.overflow="hidden"}function unlockScroll(){document.body.style.overflow=priorBodyOverflow,document.body.style.paddingRight=priorBodyPaddingRight}function openDialog(){lockScroll(),root.hidden=!1,root.setAttribute("aria-hidden","false"),closeButton.focus({preventScroll:!0})}function showRelative(delta){if(gallery.length<2)return;const next=galleryIndex+delta;next<0||next>=gallery.length||(galleryIndex=next,renderItem(gallery[galleryIndex]))}function open(trigger){const info=mediaInfo(trigger);if(!info.src)return;lastTrigger=trigger,gallery=collectGalleryFromTrigger(trigger),gallery.length||(gallery=[info]);const idx=gallery.findIndex(item=>item.src===info.src);galleryIndex=idx>=0?idx:0,renderItem(gallery[galleryIndex]),openDialog()}function openGallery(items,startIndex){!Array.isArray(items)||!items.length||(gallery=items.filter(item=>item&&item.src),gallery.length&&(galleryIndex=Math.max(0,Math.min(gallery.length-1,Number(startIndex)||0)),lastTrigger=null,renderItem(gallery[galleryIndex]),openDialog()))}function close(){if(root.hidden)return;const video=mediaHolder.querySelector("video");video&&video.pause(),root.hidden=!0,root.setAttribute("aria-hidden","true"),mediaHolder.replaceChildren(),bodyHolder.replaceChildren(),gallery=[],galleryIndex=0,unlockScroll(),lastTrigger?.focus?.({preventScroll:!0}),lastTrigger=null}function trapFocus(event){if(event.key==="ArrowLeft"){event.preventDefault(),showRelative(-1);return}if(event.key==="ArrowRight"){event.preventDefault(),showRelative(1);return}if(event.key!=="Tab")return;const focusables=[...dialog.querySelectorAll('button:not([disabled]), video[controls], [href], [tabindex]:not([tabindex="-1"])')].filter(element=>!element.hidden&&element.getClientRects().length);if(!focusables.length){event.preventDefault(),dialog.focus();return}const first=focusables[0],last=focusables[focusables.length-1];event.shiftKey&&document.activeElement===first?(event.preventDefault(),last.focus()):!event.shiftKey&&document.activeElement===last&&(event.preventDefault(),first.focus())}function enhance(container=document){container.querySelectorAll?.(MEDIA_SELECTOR).forEach(element=>{(!element.hasAttribute("tabindex")||element.getAttribute("tabindex")==="-1")&&element.setAttribute("tabindex","0"),element.matches("a, button")||element.setAttribute("role","button"),element.setAttribute("aria-haspopup","dialog"),element.removeAttribute("aria-hidden")})}function interceptClick(event){const trigger=getTrigger(event.target);trigger&&(event.preventDefault(),event.stopImmediatePropagation(),open(trigger))}function interceptKeydown(event){if(event.key!=="Enter"&&event.key!==" ")return;const trigger=getTrigger(event.target);trigger&&(event.preventDefault(),event.stopImmediatePropagation(),open(trigger))}function interceptKeyup(event){getTrigger(event.target)&&(event.preventDefault(),event.stopImmediatePropagation())}function onDocumentKeydown(event){event.key==="Escape"&&!root.hidden&&(event.preventDefault(),close())}document.addEventListener("click",interceptClick,!0),document.addEventListener("keydown",interceptKeydown,!0),document.addEventListener("keyup",interceptKeyup,!0),document.addEventListener("keydown",onDocumentKeydown),enhance(),observer=new MutationObserver(mutations=>{for(const mutation of mutations)for(const node of mutation.addedNodes)node instanceof Element&&(node.matches(MEDIA_SELECTOR)?enhance(node.parentElement||document):enhance(node))}),observer.observe(document.body,{childList:!0,subtree:!0}),window.SCSReviewLightbox={open,openGallery,close,destroy(){close(),observer?.disconnect(),document.removeEventListener("click",interceptClick,!0),document.removeEventListener("keydown",interceptKeydown,!0),document.removeEventListener("keyup",interceptKeyup,!0),document.removeEventListener("keydown",onDocumentKeydown),root.remove(),document.getElementById(STYLE_ID)?.remove(),delete window.SCSReviewLightbox}}})();
//# sourceMappingURL=/cdn/shop/t/61/assets/scs-stamped-review-lightbox-fallback.js.map?v=27433782352138498981790771511
